<template>
    <div class="d-flex align-center justify-space-between w-100">
        <div class="d-flex align-center">
            <h3 class="mb-0 font-weight-medium">
                <span v-if="currentSection">Showing {{ currentSection }} of {{ totalSectionCount }} sections</span>
                <span v-else>{{ totalSectionCount }} sections</span>
            </h3>
            <span class="ml-2 text--secondary">({{ totalNotes }} notes)</span>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            currentSection: {
                type: Number,
                required: false,
            },
            totalSectionCount: {
                type: Number,
                required: true,
                default: 0
            },
            totalNotes: {
                type: Number,
                required: true,
                default: 0
            },
        }
    }
</script>
